import { useEffect, useState } from 'react';
import useMatchMedia from '../utils/use-match-media';

const useProductCardImage = ({ desktopImage, mobileImage }) => {
  const isMobile = useMatchMedia('mobile');

  const [productCardImage, setProductCardImage] = useState(isMobile ? mobileImage ?? desktopImage : desktopImage);
  useEffect(() => {
    setProductCardImage(isMobile ? mobileImage ?? desktopImage : desktopImage);
  }, [isMobile, desktopImage, mobileImage]);

  return { productCardImage };
};

export default useProductCardImage;
